import React, { useState } from "react";
import { Check } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { buildPlans } from "@/lib/plans";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// Explicit plan step of the Google B2B signup (form → plan → payment method).
export function SignupPlanDialog({ open, region, initialTier, initialCycle, onClose, onPick }) {
  const { t, lang } = useLang();
  const plans = buildPlans(region, lang).filter((p) => !p.quote);
  const [tier, setTier] = useState(initialTier && plans.some((p) => p.key === initialTier) ? initialTier : "free");
  const [cycle, setCycle] = useState(initialCycle === "annual" ? "annual" : "monthly");
  const seg = (on) => `px-4 h-9 rounded-full text-xs font-semibold transition-colors ${on ? "bg-findo-navy text-white" : "text-slate-600 hover:bg-slate-100"}`;
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-lg rounded-2xl" data-testid="signup-plan-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">{t("gs.planTitle")}</DialogTitle>
          <DialogDescription>{t("gs.planDesc")}</DialogDescription>
        </DialogHeader>
        <div className="inline-flex self-start rounded-full border border-border p-1" data-testid="signup-plan-cycle">
          <button type="button" className={seg(cycle === "monthly")} onClick={() => setCycle("monthly")} data-testid="signup-plan-cycle-monthly">{t("pricing.monthly")}</button>
          <button type="button" className={seg(cycle === "annual")} onClick={() => setCycle("annual")} data-testid="signup-plan-cycle-annual">{t("pricing.annual")} · {t("pricing.annualBadge")}</button>
        </div>
        <div className="space-y-2.5">
          {plans.map((p) => {
            const on = tier === p.key;
            const price = p.price_eur ? (cycle === "annual" ? `${Math.round(p.price_eur * 12 * 0.8)} €${t("pricing.perYear")}` : `${p.price}${t("pricing.month")}`) : p.price;
            return (
              <button type="button" key={p.key} onClick={() => setTier(p.key)} data-testid={`signup-plan-${p.key}`}
                className={`w-full flex items-center justify-between gap-3 rounded-xl border p-4 text-left transition-colors ${on ? "border-findo-indigo bg-findo-indigo/5" : "border-border hover:bg-slate-50"}`}>
                <span className="flex items-center gap-3">
                  <span className={`h-5 w-5 rounded-full border flex items-center justify-center ${on ? "bg-findo-indigo border-findo-indigo text-white" : "border-slate-300"}`}>{on && <Check size={12} />}</span>
                  <span className="font-display font-semibold text-slate-900">{p.name}</span>
                </span>
                <span className="font-bold text-findo-navy">{price}{p.price_eur ? <span className="ml-1 text-xs font-semibold text-slate-500">{t("price.ht")}</span> : null}</span>
              </button>
            );
          })}
        </div>
        <Button className="w-full h-11 rounded-xl font-semibold" onClick={() => onPick({ tier, cycle })} data-testid="signup-plan-continue">
          {t("gs.continue")}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
